function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOpsDarkblueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h110v110H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.947 29.82a32.07 32.07 0 0 0-3.901 3.076l8.043 8.043a20.312 20.312 0 0 1 2.192-1.729 18.696 18.696 0 0 1 3.237-1.749 19.547 19.547 0 0 1 3.559-1.066 19.347 19.347 0 0 1 3.74-.362c5.248 0 9.993 2.131 13.411 5.549a19 19 0 0 1 4.122 6.173 18.928 18.928 0 0 1 1.448 7.259c0 2.554-.503 5.007-1.448 7.259a19 19 0 0 1-10.295 10.295 18.941 18.941 0 0 1-7.258 1.447 21.33 21.33 0 0 1-4.042-.382 17.082 17.082 0 0 1-3.518-1.126c-1.126-.523-2.212-1.186-3.298-1.99a30.604 30.604 0 0 1-3.177-2.775L42.885 45.865l-8.022 8.023 21.876 21.877a40.94 40.94 0 0 0 4.665 4.021 32.048 32.048 0 0 0 5.127 3.016 28.537 28.537 0 0 0 5.811 1.93c2.031.443 4.163.664 6.455.664 4.122 0 8.023-.825 11.602-2.292a30.302 30.302 0 0 0 9.852-6.595 30.506 30.506 0 0 0 6.595-9.853c1.488-3.559 2.292-7.48 2.292-11.602a30.45 30.45 0 0 0-2.292-11.602 30.302 30.302 0 0 0-6.595-9.852 30.512 30.512 0 0 0-9.852-6.595c-3.559-1.488-7.48-2.292-11.602-2.292a30.34 30.34 0 0 0-5.892.583c-1.95.402-3.86.985-5.71 1.729a30.618 30.618 0 0 0-5.248 2.795Z",
    style: {
      fill: "#29b5e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.053 80.208a31.661 31.661 0 0 0 3.901-3.076l-8.043-8.043a22.482 22.482 0 0 1-2.192 1.729 17.406 17.406 0 0 1-3.237 1.75 18.151 18.151 0 0 1-3.559 1.065 19.268 19.268 0 0 1-3.74.362 18.917 18.917 0 0 1-13.411-5.549 19 19 0 0 1-4.122-6.173 18.928 18.928 0 0 1-1.448-7.259c0-5.248 2.131-9.993 5.55-13.411a18.984 18.984 0 0 1 6.172-4.122 18.928 18.928 0 0 1 7.259-1.448c1.448 0 2.775.141 4.042.382 1.266.261 2.433.643 3.518 1.126 1.126.523 2.212 1.186 3.298 1.991 1.086.804 2.131 1.729 3.177 2.774l21.876 21.877 8.023-8.023-21.876-21.876c-1.508-1.508-3.057-2.856-4.665-4.022a32.088 32.088 0 0 0-5.128-3.016 28.39 28.39 0 0 0-5.79-1.93c-2.031-.443-4.163-.664-6.455-.664-4.122 0-8.023.825-11.602 2.292a30.32 30.32 0 0 0-9.852 6.596 30.501 30.501 0 0 0-6.595 9.852C1.666 46.951.862 50.872.862 54.994s.824 8.023 2.292 11.602a30.302 30.302 0 0 0 6.595 9.852 30.512 30.512 0 0 0 9.852 6.595c3.559 1.488 7.48 2.293 11.602 2.293 1.991 0 3.961-.202 5.872-.584 1.95-.402 3.86-.965 5.71-1.729 1.83-.784 3.619-1.709 5.268-2.815Z",
    style: {
      fill: "#24323d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOpsDarkblueIcon);
export default __webpack_public_path__ + "static/media/DataOps_darkblue_icon.f2935e373d64e18042b89b56cb122059.svg";
export { ForwardRef as ReactComponent };